import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import * as React from 'react';

import ComingSoon from '@/components/ComingSoon';
import Seo from '@/components/Seo';

export const DEFAULT_LANGUAGE = 'en_EN';

export default function HomePage(_ = { isServerRendered: false }) {
  const { t } = useTranslation('common');

  return (
    <>
      <Seo templateTitle={t('coming-soon.title')} />

      <main>
        <section>
          <ComingSoon />
        </section>
      </main>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const defaultLanguage =
    (ctx.req.headers.browserlocale as string) ?? ctx.locale ?? DEFAULT_LANGUAGE;

  return {
    props: {
      ...(await serverSideTranslations(defaultLanguage, ['common'])),
      isServerRendered: true,
    },
  };
};
